// extracted by mini-css-extract-plugin
module.exports = {"labelGroup":"AccionaFormItem_labelGroup__16GoM"};